import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SearchIcon from '@material-ui/icons/Search';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  shouldShowResults, useSearchBarDispatch,
  useSearchBarState,
  onSelectSearchType,
} from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SearchBarContext';
import AdvancedTypography from 'Components/UI/AdvancedTypography';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const styles = (theme) => ({
  root: {
    height: theme.dimensions.xs,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    transform: 'scale(2)',
    fill: theme.palette.facet.primaryGray,
  },
  title: {
    paddingTop: theme.spacing(3),
  },
  subtitle: {
    paddingTop: theme.spacing(1),
  },
  searchTypeButton: {},
  searchTypeButtonText: {},
});

const EmptyResults = ({
  className,
  classes,
}) => {
  const eventTracking = useEventTrackingLogEvent();
  const searchBarDispatch = useSearchBarDispatch();
  const searchBarState = useSearchBarState();
  const {
    searchResponse,
    searchTerm,
    searchType,
    suggestedFilterOptions,
  } = searchBarState;

  // Show the empty list if you would normally be showing results but there are none found
  const showEmptyList = (
    suggestedFilterOptions.length === 0
    && shouldShowResults(searchBarState, searchTerm)
    && searchResponse
    && searchResponse.resources().length() === 0
  );

  if (!showEmptyList) {
    return null;
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <SearchIcon
        className={classes.icon}
      />
      <Typography
        className={classes.title}
        variant={'h5'}
        weight={'bold'}
        color={'primaryGray'}
      >
        {'No search results found'}
      </Typography>
      <Typography
        className={classes.subtitle}
        variant={'body1'}
        weight={'medium'}
        color={'primaryGray'}
      >
        {'Please try again with a different search query.'}
      </Typography>
      {(searchType !== null) ? (
        <Button
          className={classes.searchTypeButton}
          color={'accentBlue'}
          onClick={() => {
            eventTracking.logEvent('search > clear search type from empty results');
            onSelectSearchType(searchBarDispatch, searchBarState, null, eventTracking)();
          }}
        >
          <AdvancedTypography
            className={classes.searchTypeButtonText}
            fragments={[
              {
                color: 'accentBlue',
                variant: 'body1',
                weight: 'medium',
                text: "I didn't mean to search by ",
              },
              {
                color: 'accentBlue',
                variant: 'body1',
                text: searchType.toUpperCase(),
                weight: 'bold',
              },
            ]}
          />
        </Button>
      ) : null}
    </Box>
  );
};

EmptyResults.defaultProps = {
  className: '',
};

EmptyResults.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EmptyResults);
